import { createTheme } from '@mui/material';

export const muiTheme = createTheme({
  typography: {
    fontSize: 20,
    fontFamily: "'GillSansRegular', 'GillSansLight', 'Raleway', serif",
  },
});

export const RADIO_BUTTON_STYLE = {
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
  color: '#0961a7',
  '&.Mui-checked': {
    color: '#0961a7',
  },
};
